import calendarSettingsParams from '../BookingCalendar/settingsParams';

export default calendarSettingsParams;
